/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass
 */
export interface FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass
     */
    Token: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass(value: object): value is FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass {
    return FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassToJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass {
    return FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
    };
}

